document.addEventListener('DOMContentLoaded', function () {
    /**
     * 2. Reveals elements hidden on load with a fade-in effect.
     */
    function initFadeInElements() {
        const hiddenEls = document.querySelectorAll('[hide-on-load]');
        hiddenEls.forEach(el => {
            el.style.visibility = 'visible';
            requestAnimationFrame(() => {
                el.classList.add('show');
            });
        });
    }

    /**
     * 4. Adds a 'few-items' class to accordion wrappers with less than 4 links for styling purposes.
     */
    function initAccordionItemCounter() {
        document.querySelectorAll('.accordion-content-wrapper').forEach(wrapper => {
            if (wrapper.querySelectorAll('.accordion-link').length < 4) {
                wrapper.classList.add('few-items');
            }
        });
    }

    /**
     * 5. Initializes the hover-activated navbar dropdown menu using GSAP.
     */
    function initNavbarDropdown() {
        if (typeof gsap === 'undefined') {
            console.error('GSAP library is not loaded.');
            return;
        }
        if (window.innerWidth <= 991) return; // Desktop only

        document.querySelectorAll('.nav-bar').forEach((mainNav) => {
            const parentContainer =
                mainNav.closest('.main-navbar-container, .navbar-container, header, .header, body') ||
                document.body;

            const dropdown = parentContainer.querySelector('.dropdown-shop-all');
            const shopAllLinks = mainNav.querySelectorAll('[shop-all]');
            const navBg = parentContainer.querySelector('.nav-bg-overlay');
            let hideTimeout;

            if (!dropdown || shopAllLinks.length === 0) return;

            gsap.set(dropdown, { height: 0, opacity: 0, pointerEvents: 'none', display: 'none' });
            if (navBg) navBg.style.pointerEvents = 'none';

            const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

            function resetFeatureImages(dropdownEl) {
                dropdownEl.querySelectorAll('.image-feature').forEach((img) => {
                    gsap.killTweensOf(img);
                    gsap.set(img, { scale: 1, transformOrigin: '50% 50%' });
                });
            }

            function playOpenZoom(dropdownEl) {
                if (reduceMotionQuery.matches) return;

                dropdownEl.querySelectorAll('.image-feature').forEach((img) => {
                    gsap.killTweensOf(img);
                    // Start slightly zoomed-in, then zoom out to 1
                    gsap.set(img, { transformOrigin: '50% 50%', scale: 1.06 });
                    gsap.to(img, { scale: 1, duration: 0.9, ease: 'power2.out' });
                });
            }

            function bindFeatureHover(dropdownEl) {
                const links = dropdownEl.querySelectorAll('.dropdown-feature-link');

                links.forEach((link) => {
                    if (link.dataset.featureHoverBound === 'true') return;
                    link.dataset.featureHoverBound = 'true';

                    const img = link.querySelector('.image-feature');
                    if (!img) return;

                    gsap.set(img, { transformOrigin: '50% 50%', scale: 1 });

                    // Use mouseover/mouseout with relatedTarget guard to avoid child element jitter
                    link.addEventListener('mouseover', (e) => {
                        if (reduceMotionQuery.matches) return;
                        if (e.relatedTarget && link.contains(e.relatedTarget)) return;

                        gsap.killTweensOf(img);
                        gsap.to(img, { scale: 1.05, duration: 0.35, ease: 'power2.out' });
                    });

                    link.addEventListener('mouseout', (e) => {
                        if (reduceMotionQuery.matches) return;
                        if (e.relatedTarget && link.contains(e.relatedTarget)) return;

                        gsap.killTweensOf(img);
                        gsap.to(img, { scale: 1, duration: 0.35, ease: 'power2.out' });
                    });
                });
            }

            function showDropdown() {
                if (dropdown.classList.contains('visible')) return;
                clearTimeout(hideTimeout);

                const rows = dropdown.querySelectorAll('.drop-down-row');
                const features = dropdown.querySelectorAll('.dropdown-feature-link');
                const images = dropdown.querySelectorAll('.image-feature');

                // Kill only what this dropdown owns
                gsap.killTweensOf(dropdown);
                gsap.killTweensOf(rows);
                gsap.killTweensOf(features);
                gsap.killTweensOf(images);

                const iconShopAll = mainNav.querySelector('.icon-shop-all');
                if (iconShopAll) {
                    gsap.to(iconShopAll, { rotation: 180, duration: 0.25, ease: 'power2.out' });
                }

                mainNav.setAttribute('nav-bg-visible', '');
                document.body.classList.add('dropdown-open');
                if (navBg) navBg.classList.add('visible');

                gsap.set([...rows, ...features], { opacity: 0, y: 10 });
                gsap.set(dropdown, { display: 'block' });

                // Ensure a clean baseline, bind hover once, then play intro zoom
                resetFeatureImages(dropdown);
                bindFeatureHover(dropdown);
                playOpenZoom(dropdown);

                gsap.to(dropdown, {
                    height: 'auto',
                    opacity: 1,
                    pointerEvents: 'auto',
                    duration: 0.25,
                    ease: 'power2.out',
                    onStart: () => dropdown.classList.add('visible'),
                    onComplete: () => {
                        [...rows, ...features].forEach((el, i) => {
                            gsap.to(el, {
                                opacity: 1,
                                y: 0,
                                duration: 0.7,
                                delay: i * 0.05,
                                ease: 'power2.out',
                            });
                        });
                    },
                });
            }

            function hideDropdown() {
                if (!dropdown.classList.contains('visible')) return;

                const iconShopAll = mainNav.querySelector('.icon-shop-all');
                if (iconShopAll) {
                    gsap.to(iconShopAll, { rotation: 0, duration: 0.25, ease: 'power2.out' });
                }

                hideTimeout = setTimeout(() => {
                    const rows = dropdown.querySelectorAll('.drop-down-row');
                    const features = dropdown.querySelectorAll('.dropdown-feature-link');
                    const images = dropdown.querySelectorAll('.image-feature');

                    gsap.killTweensOf(dropdown);
                    gsap.killTweensOf(rows);
                    gsap.killTweensOf(features);
                    gsap.killTweensOf(images);

                    [...rows, ...features].forEach((el, i) => {
                        gsap.to(el, { opacity: 0, y: 10, duration: 0.3, delay: i * 0.03, ease: 'power2.inOut' });
                    });

                    gsap.to(dropdown, {
                        height: 0,
                        pointerEvents: 'none',
                        duration: 0.7,
                        delay: 0.3,
                        ease: 'power2.in',
                        onStart: () => {
                            gsap.to(dropdown, { opacity: 0, duration: 0.1, delay: 0.6 });
                        },
                        onComplete: () => {
                            // Prevent stuck hover scale when dropdown closes without mouseout firing
                            resetFeatureImages(dropdown);

                            gsap.set(dropdown, { display: 'none' });
                            dropdown.classList.remove('visible');

                            mainNav.removeAttribute('nav-bg-visible');
                            document.body.classList.remove('dropdown-open');
                            if (navBg) navBg.classList.remove('visible');
                        },
                    });
                }, 250);
            }

            shopAllLinks.forEach((link) => {
                link.addEventListener('mouseenter', showDropdown);
                link.addEventListener('mouseleave', hideDropdown);
            });

            dropdown.addEventListener('mouseenter', () => clearTimeout(hideTimeout));
            dropdown.addEventListener('mousemove', () => clearTimeout(hideTimeout));
            dropdown.addEventListener('mouseleave', hideDropdown);
        });
    }

    /**
     * 6. Initializes the main fly-out menu interaction with overlay and GSAP animations.
     */
    function initFlyOutMenu() {
        if (typeof gsap === 'undefined') {
            console.error('GSAP library is not loaded.');
            return;
        }

        const menuOverlay = document.querySelector('.menu-overlay');
        if (!menuOverlay) return;

        gsap.set(menuOverlay, { opacity: 0, display: 'none', pointerEvents: 'none' });

        const menus = document.querySelectorAll('.menu');

        menus.forEach((menuTrigger) => {
            const container = menuTrigger.closest('.main-navbar-container, .navbar-container');
            if (!container) return;

            const dropdownMenu = container.querySelector('.dropdown-menu');
            const dropdownMenuLower = dropdownMenu?.querySelector('.dropdown-menu-lower');
            const closeMenuIcon = container.querySelector('.close-menu-icon');
            const navBgOverlay = container.querySelector('.nav-bg-overlay');

            if (!dropdownMenu || !dropdownMenuLower || !closeMenuIcon) return;

            // [dropdown-animate] items are optional — mobile menus may not have them
            const animatedItems = dropdownMenu.querySelectorAll('[dropdown-animate]');
            const hasAnimatedItems = animatedItems.length > 0;

            gsap.set(dropdownMenu, { x: '100%' });
            gsap.set(closeMenuIcon, { opacity: 0 });
            if (hasAnimatedItems) {
                gsap.set(animatedItems, { opacity: 0, x: -40 });
            }

            const itemTimeline = hasAnimatedItems
                ? gsap.timeline({ paused: true }).to(animatedItems, {
                    opacity: 1,
                    x: 0,
                    duration: 0.3,
                    stagger: 0.1,
                    ease: 'power3.out',
                })
                : null;

            const closeMenu = () => {
                // Remove the overlay listener in case close was triggered by the close icon
                // rather than the overlay itself — prevents a stale once-listener from lingering
                menuOverlay.removeEventListener('click', closeMenu);

                gsap.to(closeMenuIcon, { opacity: 0, duration: 0.2, ease: 'power1.in' });

                if (hasAnimatedItems) {
                    gsap.to(animatedItems, {
                        opacity: 0,
                        x: 20,
                        duration: 0.15,
                        stagger: 0.05,
                        ease: 'power2.in',
                    });
                }

                gsap.to(dropdownMenu, {
                    x: '100%',
                    duration: 0.2,
                    ease: 'power3.in',
                    delay: 0.1,
                    onComplete: () => {
                        dropdownMenu.classList.remove('active');
                        document.body.classList.remove('menu-open');
                        if (hasAnimatedItems) {
                            gsap.set(animatedItems, { opacity: 0, x: -40 });
                        }
                        closeMenuIcon.style.pointerEvents = 'none';
                        dropdownMenuLower.style.top = '';
                        dropdownMenuLower.style.paddingTop = '';
                        dropdownMenuLower.style.position = '';
                    },
                });

                gsap.to(menuOverlay, {
                    opacity: 0,
                    duration: 0.25,
                    ease: 'power2.in',
                    onComplete: () => {
                        menuOverlay.style.pointerEvents = 'none';
                        menuOverlay.style.display = 'none';
                    },
                });

                if (container.classList.contains('main-navbar-container') && navBgOverlay) {
                    gsap.to(navBgOverlay, {
                        backgroundColor: 'rgba(0, 0, 0, 0)',
                        duration: 0.3,
                        ease: 'power2.in',
                        onComplete: () => navBgOverlay.classList.remove('visible'),
                    });
                }
            };

            const openMenu = () => {
                if (typeof window.closeAllAccordions === 'function') {
                    window.closeAllAccordions();
                }

                gsap.to(menuOverlay, {
                    opacity: 1,
                    duration: 0.2,
                    ease: 'power1.out',
                    onStart: () => {
                        menuOverlay.style.display = 'block';
                        menuOverlay.style.pointerEvents = 'auto';
                    },
                });

                // Bind a scoped, one-time overlay click that closes THIS specific menu.
                // Using removeEventListener + addEventListener (rather than { once: true })
                // so closeMenu can also safely call removeEventListener when triggered
                // via the close icon without leaving a dangling listener.
                menuOverlay.removeEventListener('click', closeMenu);
                menuOverlay.addEventListener('click', closeMenu, { once: true });

                if (container.classList.contains('main-navbar-container') && navBgOverlay) {
                    navBgOverlay.classList.add('visible');
                    gsap.to(navBgOverlay, {
                        backgroundColor: 'var(--sooty)',
                        duration: 0.4,
                        ease: 'power2.out',
                    });
                }

                gsap.to(dropdownMenu, {
                    x: '0%',
                    duration: 0.25,
                    ease: 'power1.out',
                    onStart: () => {
                        dropdownMenu.classList.add('active');
                        document.body.classList.add('menu-open');

                        if (typeof window.updateDropdownMenuPosition === 'function') {
                            window.updateDropdownMenuPosition();
                        }

                        if (typeof window.updateCloseIconPosition === 'function') {
                            setTimeout(() => window.updateCloseIconPosition(menuTrigger), 50);
                        }
                    },
                    onComplete: () => {
                        if (itemTimeline) itemTimeline.restart();
                        gsap.to(closeMenuIcon, {
                            opacity: 1,
                            duration: 0.15,
                            delay: hasAnimatedItems ? animatedItems.length * 0.06 : 0,
                            ease: 'power2.out',
                        });
                    },
                });
            };

            if (menuTrigger.dataset.flyoutBound === 'true') return;
            menuTrigger.dataset.flyoutBound = 'true';

            menuTrigger.addEventListener('click', openMenu);
            closeMenuIcon.addEventListener('click', closeMenu);
        });
    }


    /**
     * 7. Initializes accordion functionality using GSAP for animation and Lottie for icons.
     */
    function initAccordions() {
        if (typeof gsap === 'undefined' || typeof lottie === 'undefined') {
            console.error('GSAP or Lottie library is not loaded.');
            return;
        }

        const accordionItems = document.querySelectorAll('.accordion-item');
        if (accordionItems.length === 0) return;

        const LOTTIE_PATH =
            (window.THEME_ASSETS && window.THEME_ASSETS.plusIcon) || '/assets/plus-icon.json';

        function hasSublinks(contentEl) {
            if (!contentEl) return false;

            // Primary signal: actual links
            const links = contentEl.querySelectorAll('a');
            if (links.length > 0) return true;

            // Fallback: any non-empty element content
            const hasMeaningfulChild = Array.from(contentEl.children).some((child) => {
                const text = (child.textContent || '').trim();
                return text.length > 0 || child.children.length > 0;
            });

            return hasMeaningfulChild;
        }

        function setCollapsed(content) {
            gsap.set(content, { height: 0, opacity: 0, overflow: 'hidden', display: 'none' });
        }

        function openAccordion(item) {
            item.dataset.open = 'true';
            const content = item.querySelector('.accordion-content');
            const anim = item.lottieInstance;

            item.classList.add('is-open');
            if (content) {
                content.style.display = 'block';
                gsap.to(content, { height: 'auto', opacity: 1, duration: 0.4, ease: 'power2.out' });
            }

            if (anim) {
                anim.setDirection(1);
                anim.play();
            }

            const header = item.querySelector('.accordion-header');
            if (header) header.setAttribute('aria-expanded', 'true');
        }

        function closeAccordion(item) {
            item.dataset.open = 'false';
            const content = item.querySelector('.accordion-content');
            const anim = item.lottieInstance;

            item.classList.remove('is-open');

            if (content) {
                gsap.to(content, {
                    height: 0,
                    opacity: 0,
                    duration: 0.4,
                    ease: 'power2.inOut',
                    onComplete: () => {
                        content.style.display = 'none';
                    },
                });
            }

            if (anim) {
                anim.setDirection(-1);
                anim.play();
            }

            const header = item.querySelector('.accordion-header');
            if (header) header.setAttribute('aria-expanded', 'false');
        }

        accordionItems.forEach((item) => {
            const header = item.querySelector('.accordion-header');
            const content = item.querySelector('.accordion-content');
            const icon = item.querySelector('.accordion-icon');

            if (!header || !content) return;

            const expandable = hasSublinks(content);

            // Non-expandable: no Lottie, no accordion binding
            if (!expandable) {
                item.dataset.open = 'false';

                // Ensure content is not treated as a panel
                content.style.display = 'none';

                // Hide icon container if present
                if (icon) {
                    icon.style.display = 'none';
                }

                // Make header behave like a normal row/link (no toggle)
                header.setAttribute('aria-expanded', 'false');
                header.style.cursor = 'default';

                return;
            }

            // Expandable: initialize Lottie + GSAP accordion
            if (icon) {
                icon.style.display = '';
                item.lottieInstance = lottie.loadAnimation({
                    container: icon,
                    renderer: 'svg',
                    loop: false,
                    autoplay: false,
                    path: LOTTIE_PATH,
                });
            }

            item.dataset.open = 'false';
            setCollapsed(content);

            // Avoid duplicate bindings if theme hot reload / section reload occurs
            if (item.dataset.accordionBound === 'true') return;
            item.dataset.accordionBound = 'true';

            header.setAttribute('aria-expanded', 'false');
            header.style.cursor = 'pointer';

            header.addEventListener('click', (e) => {
                // If header contains a direct link, allow navigation and do not toggle
                if (e.target.closest('a')) return;

                const isOpen = item.dataset.open === 'true';

                accordionItems.forEach((other) => {
                    if (other !== item && other.dataset.open === 'true') closeAccordion(other);
                });

                if (!isOpen) openAccordion(item);
                else closeAccordion(item);
            });
        });

        window.closeAllAccordions = () => {
            accordionItems.forEach((item) => {
                if (item.dataset.open === 'true') closeAccordion(item);
            });
        };
    }

    /**
     * 8. Dynamic Dropdown Menu Positioning (tracks dynamic navbar)
     */
    function initDynamicMenuPosition() {
        const dropdownMenuLowers = document.querySelectorAll('.dropdown-menu-lower');
        const navbarContainer = document.querySelector('.navbar-container');
        const mainNavbarContainer = document.querySelector('.main-navbar-container');

        if (dropdownMenuLowers.length === 0) return;

        function getActiveNavbar() {
            const candidates = [];

            if (mainNavbarContainer) {
                const mainNav = mainNavbarContainer.querySelector('.nav-bar');
                if (mainNav) candidates.push(mainNav);
            }

            if (navbarContainer) {
                const collapsibleNav = navbarContainer.querySelector('.nav-bar');
                if (collapsibleNav) candidates.push(collapsibleNav);
            }

            let best = null;
            let bestScore = Infinity;

            candidates.forEach((nav) => {
                const rect = nav.getBoundingClientRect();
                const visible = rect.bottom > 0 && rect.top < window.innerHeight;
                if (!visible) return;

                const score = Math.abs(rect.top);
                if (score < bestScore) {
                    best = nav;
                    bestScore = score;
                }
            });

            return best;
        }

        window.updateDropdownMenuPosition = function () {
            dropdownMenuLowers.forEach((menuLower) => {
                const container = menuLower.closest('.main-navbar-container, .navbar-container');
                if (!container) return;

                const navBar = container.querySelector('.nav-bar');
                if (!navBar) return;

                let navBottom = navBar.getBoundingClientRect().bottom;

                // Account for announcement bar
                const adBanner = document.querySelector('.ad-banner-section');
                if (adBanner) {
                    const bannerBottom = adBanner.getBoundingClientRect().bottom;
                    if (bannerBottom > navBottom) navBottom = bannerBottom;
                }

                // dropdown-menu has transform applied by GSAP which breaks position:fixed on children
                // so use padding-top relative to the parent's own top instead
                const dropdownMenu = menuLower.closest('.dropdown-menu');
                const menuTop = dropdownMenu ? dropdownMenu.getBoundingClientRect().top : 0;

                menuLower.style.position = 'relative';
                menuLower.style.top = '';
                menuLower.style.paddingTop = Math.max(0, navBottom - menuTop) + 'px';
            });
        };

        document.querySelectorAll('.menu').forEach((trigger) => {
            trigger.addEventListener('click', () => {
                requestAnimationFrame(() => {
                    window.updateDropdownMenuPosition();
                });
            });
        });

        window.addEventListener(
            'scroll',
            () => {
                if (document.body.classList.contains('menu-open')) {
                    window.updateDropdownMenuPosition();
                }
            },
            { passive: true }
        );

        window.addEventListener('resize', () => {
            if (document.body.classList.contains('menu-open')) {
                window.updateDropdownMenuPosition();
            }
        });

        window.updateDropdownMenuPosition();
    }

    /**
     * 9. Position close-menu-icon over menu button
     */
    function initCloseMenuIconPosition() {
        const closeIcons = document.querySelectorAll('.close-menu-icon');
        const menuButtons = document.querySelectorAll('.menu');

        if (closeIcons.length === 0 || menuButtons.length === 0) return;

        // Cache the actual trigger that was clicked so scroll updates use the right button
        let lastActiveTrigger = null;

        window.updateCloseIconPosition = function (activeTrigger) {
            if (activeTrigger) lastActiveTrigger = activeTrigger;

            closeIcons.forEach((closeIcon) => {
                const container = closeIcon.closest('.main-navbar-container, .navbar-container');
                if (!container) return;

                const dropdownMenu = container.querySelector('.dropdown-menu');
                if (!dropdownMenu || !dropdownMenu.classList.contains('active')) return;

                const menuButton = (lastActiveTrigger && container.contains(lastActiveTrigger))
                    ? lastActiveTrigger
                    : container.querySelector('.menu');
                if (!menuButton) return;

                const menuRect = menuButton.getBoundingClientRect();

                // Force fixed positioning in JS to override any CSS/Webflow absolute override
                closeIcon.style.position = 'fixed';
                closeIcon.style.top = `${menuRect.top}px`;
                closeIcon.style.right = `${window.innerWidth - menuRect.right}px`;
                closeIcon.style.width = `${menuRect.width}px`;
                closeIcon.style.height = `${menuRect.height}px`;
                closeIcon.style.pointerEvents = 'auto';
            });
        };

        // Update on scroll (uses cached lastActiveTrigger)
        window.addEventListener('scroll', () => {
            if (document.body.classList.contains('menu-open')) {
                window.updateCloseIconPosition();
            }
        }, { passive: true });

        // Update on resize
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(window.updateCloseIconPosition, 10);
        });

        // Initial update
        window.updateCloseIconPosition();
    }

    // --- Execute all initialization functions ---
    initFadeInElements();
    initAccordionItemCounter();
    initNavbarDropdown();
    initFlyOutMenu();
    initAccordions();
    initDynamicMenuPosition();
    initCloseMenuIconPosition();
});

document.addEventListener('DOMContentLoaded', function () {
    // 1. Horizontal Scroll Indicator (Blog Slider)
    const scrollContainers = document.querySelectorAll('.horizontal-scroll-container');
    const scrollThumbs = document.querySelectorAll('.slider-head-blog');
    const indicators = document.querySelectorAll('.slider-blog');

    scrollContainers.forEach((scrollContainer, index) => {
        const scrollThumb = scrollThumbs[index];
        const indicator = indicators[index];
        if (scrollThumb && indicator) {
            scrollContainer.addEventListener('scroll', () => {
                const scrollLeft = scrollContainer.scrollLeft;
                const scrollWidth = scrollContainer.scrollWidth - scrollContainer.clientWidth;
                const indicatorWidth = indicator.offsetWidth;
                const thumbWidth = scrollThumb.offsetWidth;
                const maxThumbX = indicatorWidth - thumbWidth;
                const scrollRatio = scrollWidth > 0 ? scrollLeft / scrollWidth : 0;
                const thumbX = scrollRatio * maxThumbX;
                scrollThumb.style.transform = `translateX(${thumbX}px)`;
            });
        }
    });

    // 2. Custom Slider with Animate-in
    function getSlideDuration(instance, fallback = 10000) {
        const v = parseInt(instance.getAttribute('data-delay') || '', 10);
        return Number.isFinite(v) ? v : fallback;
    }

    function initSlider(instance) {
        if (!instance || instance.dataset.sliderInit === 'true') return;
        instance.dataset.sliderInit = 'true';

        const SLIDE_DURATION = getSlideDuration(instance, 10000);

        const selectors = instance.querySelectorAll('.selector');
        const slides = instance.querySelectorAll('.slide');
        const track = instance.querySelector('.slider-track');
        const progressCircles = instance.querySelectorAll('.progress-fg');
        const visibleSlidesCount = selectors.length;

        if (!track || slides.length === 0 || visibleSlidesCount === 0) return;

        let currentIndex = 0;
        let autoplayTimeout;
        let firstRun = true;

        function resetProgress() {
            progressCircles.forEach(circle => {
                circle.style.transition = 'none';
                circle.style.strokeDashoffset = 44;
                void circle.offsetWidth;
            });
        }

        function startProgress(index) {
            const circle = progressCircles[index];
            if (!circle) return;
            circle.style.transition = `stroke-dashoffset ${SLIDE_DURATION}ms linear`;
            circle.style.strokeDashoffset = 0;
        }

        function showSlide(index, instant = false) {
            const offset = -index * 100;
            if (instant) {
                track.style.transition = 'none';
                track.style.transform = `translateX(${offset}%)`;
                void track.offsetWidth;
                track.style.transition = 'transform 0.6s ease';
            } else {
                track.style.transform = `translateX(${offset}%)`;
            }
        }

        function animateSlideContent(index, overrideDelay = null) {
            if (typeof gsap === 'undefined') return;

            const currentSlide = slides[index];
            if (!currentSlide) return;

            const animatedElements = currentSlide.querySelectorAll('[animate-in]');
            animatedElements.forEach(el => {
                el.style.display = 'flex';
                el.style.visibility = 'visible';
            });

            gsap.set(animatedElements, { opacity: 0, y: 30 });
            gsap.to(animatedElements, {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: 'power2.out',
                stagger: 0.1,
                delay: overrideDelay !== null ? overrideDelay : (firstRun ? 0 : 0.6)
            });

            firstRun = false;
        }

        function updateSelectors(index) {
            const realIndex = index % visibleSlidesCount;
            selectors.forEach((s, i) => s.classList.toggle('active', i === realIndex));
        }

        function restartAutoplay() {
            clearTimeout(autoplayTimeout);
            autoplayTimeout = setTimeout(() => {
                const next = (currentIndex + 1) % slides.length;
                goToSlide(next);
            }, SLIDE_DURATION);
        }

        function goToSlide(index) {
            currentIndex = index;

            const hasDuplicateLast = slides.length > visibleSlidesCount;

            if (hasDuplicateLast && index === slides.length - 1) {
                showSlide(index);
                resetProgress();
                setTimeout(() => {
                    currentIndex = 0;
                    showSlide(0, true);
                    animateSlideContent(0, 0);
                    updateSelectors(0);
                    startProgress(0);
                }, 575);
            } else {
                showSlide(index);
                animateSlideContent(index, 0.6);
                resetProgress();
                updateSelectors(index);
                startProgress(index % visibleSlidesCount);
            }

            restartAutoplay();
        }

        goToSlide(0);

        selectors.forEach((selector, index) => {
            selector.addEventListener('click', () => {
                const hasDuplicateLast = slides.length > visibleSlidesCount;
                if (hasDuplicateLast && currentIndex === visibleSlidesCount - 1 && index === 0) {
                    goToSlide(slides.length - 1);
                } else {
                    goToSlide(index);
                }
            });
        });

        restartAutoplay();
    }

    document.querySelectorAll('.slider-instance').forEach(initSlider);

    // 4. Fade-In on Scroll
    const fadeObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (typeof gsap === 'undefined') return;
                requestAnimationFrame(() => {
                    const els = entry.target.querySelectorAll('[fade-in]');
                    gsap.fromTo(els, {
                        opacity: 0,
                        y: '5%',
                        visibility: 'visible'
                    }, {
                        opacity: 1,
                        y: '0%',
                        duration: 0.6,
                        ease: 'power2.out',
                        stagger: 0.1,
                        delay: 0.1
                    });
                    fadeObserver.unobserve(entry.target);
                });
            }
        });
    }, { threshold: 0.2 });

    document.querySelectorAll('.horizontal-scroll-container').forEach(wrapper => {
        fadeObserver.observe(wrapper);
    });

    // 5. Custom Toast Notification
    const toast = document.querySelector('.custom-toast');
    const closeTriggers = document.querySelectorAll('.close-toast, [close-toast]');
    const pageWrapper = document.querySelector('.page-wrapper');

    if (toast && !localStorage.getItem('customToastShown')) {
        setTimeout(() => {
            toast.classList.add('show');
            pageWrapper?.classList.add('toast-active');
            localStorage.setItem('customToastShown', 'true');
        }, 5000);
    }

    closeTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            toast?.classList.remove('show');
            pageWrapper?.classList.remove('toast-active');
        });
    });

    // 6. Multiple Slider Instances (Desktop) using non-GSAP fade-in-next
    if (window.innerWidth >= 990) {
        document.querySelectorAll('.slider-instance-wrapper').forEach(wrapper => {
            const items = wrapper.querySelectorAll('[move-item]');
            const nextBtn = wrapper.querySelector('[next-button]');
            const prevBtn = wrapper.querySelector('[previous-button]');
            const sliderHead = wrapper.querySelector('.slider-head');
            let currentIndex = 0;

            function hasPopulatedNextItem() {
                const nextItem = wrapper.querySelector('[move-item].next, [move-item][next]');
                if (!nextItem) return false;

                const hasMeaningfulText = (nextItem.textContent || '').trim().length > 0;
                const hasMedia = nextItem.querySelector('img, video, picture, source');
                const hasLinks = nextItem.querySelector('a, button');
                const hasNonEmptyChildren = Array.from(nextItem.children).some(child => {
                    return (child.textContent || '').trim().length > 0 || child.children.length > 0;
                });

                return hasMeaningfulText || !!hasMedia || !!hasLinks || hasNonEmptyChildren;
            }

            function setButtonVisibility(show) {
                if (prevBtn) prevBtn.style.display = show ? '' : 'none';
                if (nextBtn) nextBtn.style.display = show ? '' : 'none';
            }

            function showItem(index) {
                items.forEach((item, i) => {
                    item.style.opacity = (i === index) ? '1' : '0';
                    item.style.zIndex = (i === index) ? '1' : '0';
                    item.style.pointerEvents = (i === index) ? 'auto' : 'none';
                });
            }

            function animateSwitch(newIndex, direction) {
                const currentItem = items[currentIndex];
                const newItem = items[newIndex];

                currentItem.style.opacity = '0';
                currentItem.style.pointerEvents = 'none';

                setTimeout(() => {
                    currentIndex = newIndex;
                    showItem(currentIndex);

                    const fadeEls = newItem.querySelectorAll('.horizontal-scroll-container [fade-in-next]');
                    fadeEls.forEach(el => {
                        el.classList.remove('fade-in-next-visible');
                        el.style.opacity = '0';
                        el.style.transform = 'translateY(3%)';
                    });

                    setTimeout(() => {
                        fadeEls.forEach((el, j) => {
                            setTimeout(() => {
                                el.classList.add('fade-in-next-visible');
                            }, j * 100);
                        });
                    }, 200);

                    updateButtonStates();
                    if (sliderHead) alignSliderHead(direction);
                }, 150);
            }

            function alignSliderHead(direction) {
                sliderHead.style.transition = 'transform 0.4s ease';
                sliderHead.style.transform = direction === 'left' ? 'translateX(0%)' : 'translateX(100%)';
            }

            function updateButtonStates() {
                const showNav = hasPopulatedNextItem();

                setButtonVisibility(showNav);

                if (prevBtn) {
                    prevBtn.disabled = !showNav || currentIndex === 0;
                }

                if (nextBtn) {
                    nextBtn.disabled = !showNav || currentIndex === items.length - 1;
                }
            }

            nextBtn?.addEventListener('click', () => {
                if (!hasPopulatedNextItem()) return;
                if (currentIndex < items.length - 1) {
                    animateSwitch(currentIndex + 1, 'right');
                }
            });

            prevBtn?.addEventListener('click', () => {
                if (!hasPopulatedNextItem()) return;
                if (currentIndex > 0) {
                    animateSwitch(currentIndex - 1, 'left');
                }
            });

            showItem(currentIndex);
            updateButtonStates();

            window.addEventListener('resize', updateButtonStates);
        });
    }
});

/**
 * Advanced Image Loading & Optimization
 * Add this to a new JS file or your existing scripts
 */
document.addEventListener("DOMContentLoaded", function () {
    // ============================================
    // 1. INTERSECTION OBSERVER FOR LAZY LOADING
    // ============================================
    const imagesToAnimate = document.querySelectorAll('.item-image');

    // Set initial loading state
    imagesToAnimate.forEach(img => {
        img.classList.add('is-loading');
    });

    const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;

                // Remove loading state when image enters viewport
                img.classList.remove('is-loading');

                // If image has a data-src, load it
                if (img.dataset.src) {
                    img.src = img.dataset.src;
                    delete img.dataset.src;
                }

                // Stop observing this image
                observer.unobserve(img);
            }
        });
    }, {
        rootMargin: '50px 0px', // Start loading 50px before entering viewport
        threshold: 0.01
    });

    // Observe all images
    imagesToAnimate.forEach(img => {
        imageObserver.observe(img);
    });

    // ============================================
    // 2. ADAPTIVE IMAGE QUALITY (Connection-aware)
    // ============================================
    function getConnectionSpeed() {
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

        if (!connection) return 'unknown';

        const effectiveType = connection.effectiveType;

        // Map connection types to quality levels
        const qualityMap = {
            'slow-2g': 'low',
            '2g': 'low',
            '3g': 'medium',
            '4g': 'high'
        };

        return qualityMap[effectiveType] || 'medium';
    }

    // ============================================
    // 3. PRELOAD NEXT IMAGES IN SLIDER
    // ============================================
    function preloadSliderImages() {
        const slider = document.querySelector('.slider-instance');
        if (!slider) return;

        const currentSlide = slider.querySelector('.w-slide:not([aria-hidden="true"])');
        if (!currentSlide) return;

        const nextSlide = currentSlide.nextElementSibling;
        if (!nextSlide) return;

        const nextImage = nextSlide.querySelector('img[loading="lazy"]');
        if (nextImage && nextImage.dataset.src) {
            // Preload the next image
            const preloadLink = document.createElement('link');
            preloadLink.rel = 'preload';
            preloadLink.as = 'image';
            preloadLink.href = nextImage.dataset.src;
            document.head.appendChild(preloadLink);
        }
    }

    // Run preload on slider change
    document.querySelectorAll('.slider-instance').forEach(slider => {
        slider.addEventListener('click', preloadSliderImages);
    });

    // ============================================
    // 4. SMART IMAGE SRCSET SWITCHING
    // ============================================
    function updateImageSrcset() {
        document.querySelectorAll('img[srcset]').forEach(img => {
            // Let browser handle srcset selection naturally
            // This is just for logging/debugging
            const currentSrc = img.currentSrc || img.src;
            img.dataset.currentSize = currentSrc;
        });
    }

    // Update on resize (debounced)
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateImageSrcset, 250);
    });

    // ============================================
    // 6. PERFORMANCE MONITORING
    // ============================================
    if ('PerformanceObserver' in window) {
        const perfObserver = new PerformanceObserver((list) => {
            list.getEntries().forEach((entry) => {
                if (entry.entryType === 'largest-contentful-paint') {
                    console.log('LCP:', entry.renderTime || entry.loadTime);
                }
            });
        });

        try {
            perfObserver.observe({ entryTypes: ['largest-contentful-paint'] });
        } catch (e) {
            // Browser doesn't support LCP observation
        }
    }

    // ============================================
    // 7. INITIALIZE ON LOAD
    // ============================================
    updateImageSrcset();

    // Add connection quality class to body
    const quality = getConnectionSpeed();
    document.body.dataset.connectionQuality = quality;

    console.log('Image optimization initialized. Connection quality:', quality);
});

/**
 * Enhanced changeProductImage function with responsive image support
 */
function changeProductImage(swatchElement) {
    const productCard = swatchElement.closest('.item-link');
    const productImage = productCard.querySelector('.product-main-image');
    const coloursContainer = swatchElement.closest('.product-colours');
    const variationImages = JSON.parse(coloursContainer.getAttribute('data-variation-images'));
    const selectedValue = swatchElement.getAttribute('data-variation-value');

    // Remove active class from all swatches
    coloursContainer.querySelectorAll('.checkmark').forEach(checkmark => {
        checkmark.classList.remove('active');
    });

    // Add active class to clicked swatch
    swatchElement.querySelector('.checkmark').classList.add('active');

    // Update image and button
    if (variationImages && variationImages[selectedValue]) {
        const newVariationId = variationImages[selectedValue].variation_id;

        // Fade out
        productImage.style.opacity = '0';

        setTimeout(() => {
            productImage.src = variationImages[selectedValue].url;
            productCard.setAttribute('data-current-variation', newVariationId);

            // Update href
            const baseUrl = productCard.href.split('?')[0];
            productCard.href = baseUrl + '?variant=' + newVariationId;



            // Fade in
            productImage.style.opacity = '1';
        }, 150);
    }
}

document.addEventListener('click', (e) => {
    const btn = e.target.closest('.close-ad-banner');
    if (!btn) return;
    const banner = btn.closest('.ad-banner');
    if (banner) banner.style.display = 'none';
});

(function () {
    const mq = window.matchMedia("(max-width: 991px)");

    function applyClosed(panel) {
        panel.style.maxHeight = "0px";
    }

    function applyOpen(panel) {
        panel.style.maxHeight = panel.scrollHeight + "px";
    }

    function init() {
        const items = document.querySelectorAll(".item-info.footer-option");

        items.forEach((item) => {
            const panel = item.querySelector(".wrapper-footer-link");
            if (!panel) return;

            // Ensure a known starting state on mobile
            if (mq.matches && !item.classList.contains("is-open")) {
                applyClosed(panel);
            } else {
                panel.style.maxHeight = "";
            }

            if (item._accordionBound) return;
            item._accordionBound = true;

            item.addEventListener("click", (e) => {
                if (!mq.matches) return;

                // Avoid toggling when clicking an actual link inside the panel
                if (e.target.closest(".wrapper-footer-link a")) return;

                const isOpen = item.classList.toggle("is-open");
                if (isOpen) applyOpen(panel);
                else applyClosed(panel);
            });
        });
    }

    window.addEventListener("resize", () => {
        document.querySelectorAll(".item-info.footer-option.is-open .wrapper-footer-link")
            .forEach((panel) => {
                if (mq.matches) panel.style.maxHeight = panel.scrollHeight + "px";
                else panel.style.maxHeight = "";
            });
    });

    document.addEventListener("DOMContentLoaded", init);
})();

/**
 * Shopify Cart Count Updater
 * Updates [li-element="mini-cart-item-count"] after any add-to-cart action.
 */
(function () {
    function updateCartCount() {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                document.querySelectorAll('[li-element="mini-cart-item-count"]').forEach(el => {
                    el.textContent = cart.item_count;
                });
            })
            .catch(err => console.warn('Cart count update failed:', err));
    }

    // Intercept fetch calls to Shopify cart endpoints
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
        const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
        const isCartAdd = url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear');

        return originalFetch.apply(this, args).then(response => {
            if (isCartAdd && response.ok) {
                updateCartCount();
            }
            return response;
        });
    };

    // Also cover XMLHttpRequest (some Shopify themes / apps use it)
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
        this._cartUrl = url;
        return originalXHROpen.apply(this, [method, url, ...rest]);
    };

    XMLHttpRequest.prototype.send = function (...args) {
        const url = this._cartUrl || '';
        const isCartAdd = url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear');

        if (isCartAdd) {
            this.addEventListener('load', function () {
                if (this.status >= 200 && this.status < 300) {
                    updateCartCount();
                }
            });
        }

        return originalXHRSend.apply(this, args);
    };
})();
(function () {
    var navbar = document.querySelector('.nav-bar.collapsible');
    if (!navbar) return;

    var targets = Array.from(document.querySelectorAll('[data-nav-transparent]'));
    if (!targets.length) return;

    var navHeight = navbar.offsetHeight || 80; // cached once

    function check() {
        var atTop = targets.some(function (el) {
            var top = el.getBoundingClientRect().top;
            return top >= 0 && top <= navHeight;
        });
        navbar.classList.toggle('is-transparent', atTop);
    }

    window.addEventListener('scroll', check, { passive: true });
    check();
})();
gsap.registerPlugin(ScrollTrigger);

  function revealOnce(batch, vars) {
    const fresh = batch.filter((el) => !el.dataset.revealed);
    if (!fresh.length) return;
    gsap.to(fresh, vars);
    fresh.forEach((el) => (el.dataset.revealed = 1));
  }

  document.addEventListener('DOMContentLoaded', () => {
    ScrollTrigger.batch('[fade-opacity]', {
      interval: 0.1,
      batchMax: 10,
      start: 'top 75%',
      onEnter: (batch) => revealOnce(batch, { autoAlpha: 1, duration: 1, stagger: 0.1 }),
      onEnterBack: (batch) => revealOnce(batch, { autoAlpha: 1, duration: 1, stagger: 0.1 }),
    });

    window.addEventListener('load', () => ScrollTrigger.refresh());
  });